import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { CurrencyType } from '../../../enums/CurrencyType';
import { Option } from '../../../types/Option';
import { SharedSelectProps } from '../../../types/SharedSelectProps';
import { Select } from '../Select';
import { useOptions } from './useOptions';

interface Props<M> extends SharedSelectProps<CurrencyType, M> {
  onFilterOption?: (option: Option<CurrencyType>) => boolean;
}

export const CurrencySelect = memo(
  <M extends boolean>({ value, onChange, ...rest }: Props<M>) => {
    const options = useOptions();
    const intl = useIntl();

    return (
      <Select
        {...rest}
        options={options}
        placeholder={intl.formatMessage({
          id: 'Select.CurrencySelect.placeholder',
          defaultMessage: 'Select currency...',
          description: 'Placeholder text for currency select',
        })}
        value={value}
        onChange={onChange}
      />
    );
  },
);
